<div class="categories container">
  <h2 class="categories__title">Categorias</h2>
  <div class="categories__content-box">
    <a *ngFor="let item of items" class="categories__content-box__item" target="_blank" [href]="item.href" [style]="getBackground(item.img)">
      <p class="categories__content-box__item__text">{{ item.text }}</p>
    </a>
  </div>
</div>
